import React, { useContext } from "react";
import axios from "axios";
import { Card, Row, Container, Col, Button } from "react-bootstrap";
import AddComment from "../components/review&ratings/AddComment";
import Comments from "../components/review&ratings/Comments";
import Ratings from "../components/review&ratings/Ratings";
import { directoryContext } from "../context/Context";

const DetailedView = () => {
  const [DetailedView, setDetailedView] = React.useState([]);
  const id = window.location.pathname.split("/")[2];
  const [show, setShow] = React.useState(false);
  const { reviewsState, reviewDispatch } = useContext(directoryContext);

  // const fetchUserDetails = async () => {
  //   try {
  //     const res = await axios.get(`https://wd.ekanatechnologies.in/api/v1/auth/get-users`);
  //     if (res.status === 200) {
  //       setUsers(res.data.users)

  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const fetchReviews = async (id) => {
    try {
      const res = await axios.get(
        `https://www.api.webdirectories.info/api/review/${id}`
      );
      if (res.status === 200) {
        reviewDispatch({ type: "FETCH_REVIEWS", payload: res.data });
      }
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    const incrementReview = async () => {
      try {
        const res = await axios.patch(
          "https://www.api.webdirectories.info/api/listing/increment-views/" +
            id
        );
        if (res.status === 200) {
          fetchReviews(id);
        }
      } catch (error) {
        console.log(error);
      }
    };
    incrementReview();
  }, []);

  React.useEffect(() => {
    if (id) {
      fetch("https://www.api.webdirectories.info/api/listing/get/" + id)
        .then((res) => res.json())
        .then((data) => {
          setDetailedView(data);
        });
    }

    fetchReviews(id);
  }, [id]);

  if (DetailedView.length <= 0) return <h1>NO items</h1>;

  const averageRating = (reviews) => {
    let sum = 0;
    let count = 0;
    reviews.forEach((review) => {
      sum += review.rating;
      count++;
    });
    return sum / count;
  };
  //src="https://web.archive.org/web/20121125083022im_/http://images.shrinktheweb.com/xino.php?stwembed=1&stwxmax=320&stwymax=240&stwaccesskeyid=b0bc114ca3c813e&stwurl=http://www.directoryfire.com"
  return (
    <Container fluid>
      <Row className="d-flex align-items-center justify-content-center">
        <Col md={8} className="mx-3 my-3 ">
          <Card bg="light">
            <Card.Body>
              <Card.Title>
                <div className="d-flex align-items-center justify-content-center">
                  <h4>{DetailedView?.businessName}</h4>
                  <a
                    href={DetailedView.websiteURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link text-primary mx-2 text-center"
                    style={{ fontSize: "1.2rem" }}
                  >
                    <u>{DetailedView.websiteURL}</u>
                  </a>
                </div>
              </Card.Title>
              <Row className="my-3">
                <Col md={6}>
                  <Card.Text>
                    <h5> Directory Statistics and Details </h5>

                    <div className="d-flex  flex-column align-items-center justify-content-center">
                      <img
                        className="py-3 my-3"
                        style={{
                          objectFit: "contain",
                          height: "300px",
                          border: "1px solid green",
                        }}
                        src={`https://api.webdirectories.info/thumbnails/${DetailedView._id}.jpg`}
                        alt=""
                      />
                      <p>
                        <strong>Domain Authority:</strong>{" "}
                        {DetailedView?.pageRank}
                      </p>
                      <p>
                        <strong>Monthly Visits:</strong>{" "}
                        {DetailedView?.alexaRank}
                      </p>
                      {
                        /// if directory type is not free
                        DetailedView.listingType !== "Free" && (
                          <p>
                            <strong>Directory Type:</strong>{" "}
                            {DetailedView?.listingType}
                          </p>
                        )
                      }
                      <p>
                        <p>
                          <strong>WD Rank:</strong> {DetailedView?.wdRank}
                        </p>
                        <strong>Number of times viewed :</strong>{" "}
                        {DetailedView?.views}
                      </p>

                      {DetailedView.listingType === "Niche" && (
                        <p>
                          <strong>Sub Category:</strong>{" "}
                          {DetailedView?.subNiche}
                        </p>
                      )}
                    </div>
                  </Card.Text>
                </Col>
                <Col md={6}>
                  <Card.Text>
                    <h5 className="d-flex "> Contact Details </h5>
                    <div className="d-flex flex-column align-items-start justify-content-center my-3 ">
                      <p className="d-flex">
                        <strong> Owner :</strong> {DetailedView?.user}
                      </p>
                      <p>
                        <strong>Email:</strong> {DetailedView?.email}
                      </p>
                      <p className="d-flex align-items-center justify-content-center ">
                        <strong>Phone:</strong> {DetailedView?.phone}
                      </p>
                      <p className=" ">
                        {" "}
                        <strong>Address:</strong> {DetailedView?.address}
                      </p>
                      <p className="d-flex  ">
                        {" "}
                        <strong>Date Added:</strong>{" "}
                        {new Date(DetailedView?.createdAt).toUTCString()}
                      </p>

                      <p className="d-flex  flex-column align-items-center justify-content-between ">
                        {" "}
                        <strong>Description :</strong>
                        {DetailedView.description}{" "}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <p className="d-flex flex-column">
                        <strong>Price</strong>{" "}
                        {DetailedView.price === null
                          ? "Free"
                          : ` $${DetailedView.price}`}
                      </p>

                      <p className="d-flex flex-column">
                        <strong>Directory Script:</strong>{" "}
                        {DetailedView?.dScript}
                      </p>
                    </div>
                  </Card.Text>
                </Col>
                <Col md={12} className="my-2">
                  <Ratings rating={averageRating(reviewsState.reviews)} />
                  <p>Number of Reviews : {reviewsState.reviews.length} </p>
                </Col>
              </Row>

              {/* <p>
                <strong>Directory URL:</strong>{" "}
                <a href={DetailedView?.websiteURL} target="_blank">
                  {DetailedView?.websiteURL}
                </a>
              </p>
              <p>
                <strong>Directory Owner Profile:</strong> {DetailedView?.user}
              </p>
              <p>
                <strong>Directory Type:</strong> {DetailedView?.listingType}
              </p>
              {DetailedView.listingType === "Niche" && (
                <p>
                  <strong>Sub Category:</strong> {DetailedView?.subNiche}
                </p>
              )}
              <p>
                <strong>Price:</strong> {DetailedView?.businessName}
              </p>
              <p>
                <strong>Directory Script:</strong> {DetailedView?.dScript}
              </p>
              <p>
                <strong>Description:</strong> {DetailedView?.description}
              </p>
              <p>
                <strong>Domain Authority:</strong> {DetailedView?.pageRank}
              </p>
              <p>
                <strong>Monthly Visits:</strong> {DetailedView?.alexaRank}
              </p>
              <p>
                <strong>WD Rank:</strong> {DetailedView?.wdRank}
              </p>
              <Ratings rating={averageRating(reviewsState.reviews)} />
              <p>Number of Reviews : {reviewsState.reviews.length} </p>

              <h4
                style={{
                  fontSize: "1.154rem",
                  fontWeight: "600",
                  color: "#566985",
                }}
                className="mt-5 mb-0"
              >
                comments -2
              </h4>
               */}
              <hr />

              <div className="d-flex align-items-center justify-content-center mx-3">
                <button
                  className="btn btn-primary "
                  onClick={() => setShow(true)}
                >
                  <i class="bi bi-pencil-square"></i>
                  Add Comment
                </button>
                <h4
                  style={{
                    fontSize: "1.154rem",
                    fontWeight: "600",
                    color: "#566985",
                  }}
                  className="text-center  mx-3"
                >
                  comments -{reviewsState.reviews.length}
                </h4>
              </div>
              <hr />
              {reviewsState.reviews.map((review) => (
                <Comments review={review} key={review._id} />
              ))}

              <AddComment show={show} setShow={setShow} listingId={id} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default DetailedView;
